// game/client/src/buildings/end-screen.ts
//
// End-screen overlay — shown when `room.state.matchState === "ended"`.
// Result label (`VICTORY` / `DEFEAT` / `DRAW`) is computed locally from
// `me.teamId` vs `state.winningTeamId` (255 = draw). The "Play Again" button
// invokes the `onPlayAgain` callback supplied at construction — the caller
// (main.ts) leaves the match (consented) and reloads back to the landing menu.
//
// `show()` is idempotent and called every frame while `matchState==="ended"`;
// the DOM is already populated, so subsequent calls just rewrite textContent
// (cheap) and re-toggle the .v / .d color class on the title.
export interface EndScreen {
  show(opts: { result: "victory" | "defeat" | "draw"; winningTeamId: number }): void;
  hide(): void;
}

export function createEndScreen(onPlayAgain: () => void): EndScreen {
  const root = document.createElement("div");
  root.className = "end-screen";
  root.style.display = "none";
  root.innerHTML = `
    <div class="end-screen__inner">
      <div class="end-screen__title"></div>
      <div class="end-screen__sub">Match concluded.</div>
      <button class="end-screen__btn">Play Again</button>
    </div>`;
  document.body.appendChild(root);

  const titleEl = root.querySelector(".end-screen__title") as HTMLDivElement;
  const btnEl = root.querySelector(".end-screen__btn") as HTMLButtonElement;
  btnEl.addEventListener("click", () => {
    onPlayAgain();
  });

  function show({ result }: { result: "victory" | "defeat" | "draw"; winningTeamId: number }): void {
    root.style.display = "flex";
    titleEl.textContent = result === "victory" ? "VICTORY" : result === "defeat" ? "DEFEAT" : "DRAW";
    titleEl.classList.toggle("v", result === "victory");
    titleEl.classList.toggle("d", result === "defeat");
  }

  function hide(): void {
    root.style.display = "none";
  }

  return { show, hide };
}
